import { render } from "./driver-profile.vue?vue&type=template&id=77d08c0c"
import script from "./driver-profile.vue?vue&type=script&lang=js"
export * from "./driver-profile.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__